import { render, staticRenderFns } from "./TargetingIpBlocked.vue?vue&type=template&id=7594ad93&"
import script from "./TargetingIpBlocked.vue?vue&type=script&lang=js&"
export * from "./TargetingIpBlocked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports